<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 d-inline-block mb-0">Order Retry : </h6>
                    </div>
                </div>
                <div class="row align-items-center py-4">
                    <div class="col-md-4 mt-2">
                        <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempFilterField"
                            placeholder="Select Order Type" @change="handleTempFieldChange">
                            <el-option class="select-primary" v-for="item in selectOptions" :key="item" :label="item"
                                :value="item" />
                        </el-select>
                    </div>
                    <div class="col-md-4 mt-2">
                        <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempTradeField"
                            placeholder="Select Trade Action" @change="handleTempFieldChange">
                            <el-option class="select-primary" v-for="item in tradeOptions" :key="item" :label="item"
                                :value="item" />
                        </el-select>
                    </div>
                    <div class="col-md-4 mt-2">
                        <el-select v-model="tempPortfolioNames" multiple filterable placeholder="Select Portfolios"
                            class="w-100">
                            <el-option v-for="option in portfolioSelectOptions" :key="option" :label="option"
                                :value="option" />
                        </el-select>
                    </div>
                </div>
                <el-table class="table-responsive table-flush" header-row-class-name="thead-light"
                    row-key="strategyName" :data="groupedStrategies" @selection-change="onSelectionChange">
                    <el-table-column type="selection" align="left" width="100" />
                    <el-table-column label="Strategy Name" min-width="220px" prop="strategyName">
                        <template v-slot="{ row }">
                            <b>{{ row.portfolioName }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180px" align="left" label="Actions">
                        <template v-slot:default="props">
                            <base-button @click="viewDetails(props.row)" size="sm" type="primary">View
                                Details</base-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="d-flex justify-content-end p-4">
                    <base-button type="success" size="sm" @click="confirmSelection">Confirm</base-button>
                </div>
            </base-header>
        </div>
    </div>
</template>
<script>
import { ElTable, ElTableColumn, ElSelect, ElOption } from "element-plus";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
    components: {
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    data() {
        return {
            tempFilterField: "",
            tempTradeField: "",
            tempPortfolioNames: [],
            selectOptions: ["Entry", "Exit"],
            tradeOptions: ["Buy", "Sell", "Short", "Cover"],
            orderDetails: [],
            selectedStrategies: [],
        };
    },
    computed: {
        portfolioSelectOptions() {
            const names = this.orderDetails.map(order => order.portfolioName);
            return [...new Set(names.filter(Boolean))];
        },
        groupedStrategies() {
            const resultMap = new Map();
            for (const strategy of this.orderDetails) {
                const key = strategy.portfolioName;
                if (this.tempPortfolioNames.length && !this.tempPortfolioNames.includes(key)) {
                    continue;
                }
                const isEntry = this.tempFilterField === 'Entry';
                const isExit = this.tempFilterField === 'Exit';
                const entryOrders = (strategy.entryOrders || [])
                    .filter(o => o.id !== null)
                    .map(o => ({
                        ...o,
                        type: 'Entry',
                        userId: strategy.userRefId
                    }));
                const exitOrders = (strategy.exitOrders || [])
                    .filter(o => o.id !== null)
                    .map(o => ({
                        ...o,
                        type: 'Exit',
                        userId: strategy.userRefId
                    }));
                let relevantOrders = [];
                if (isEntry) {
                    relevantOrders = entryOrders;
                } else if (isExit) {
                    relevantOrders = exitOrders;
                } else {
                    relevantOrders = [...entryOrders, ...exitOrders];
                }
                if (this.tempTradeField) {
                    relevantOrders = relevantOrders.filter(e =>
                        e.trigger && e.trigger.toUpperCase() === this.tempTradeField.toUpperCase()
                    );
                }
                if (!relevantOrders.length) continue;
                if (!resultMap.has(key)) {
                    resultMap.set(key, {
                        portfolioName: key,
                        orders: []
                    });
                }
                resultMap.get(key).orders.push(...relevantOrders);
            }
            return Array.from(resultMap.values());
        }
    },
    methods: {
        getOrderDetails() {
            this.$store.dispatch("orderStore/getOrderRetryDetails", null, { root: true })
                .then(response => {
                    this.orderDetails = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        onSelectionChange(selection) {
            this.selectedStrategies = selection;
        },
        viewDetails(row) {
            const strategy = this.groupedStrategies.find(s => s.portfolioName === row.portfolioName);
            if (strategy) {
                sessionStorage.setItem("selectedStrategyOrders", JSON.stringify(strategy));
                this.$router.push({ name: 'OrderDetail' });
            } else {
                alert("Strategy not found.");
            }
        },
        showSwal(type) {
            if (type === "success") {
                swal.fire({
                    title: `Success`,
                    text: "Request to reorder the positions are placed.",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                    icon: "success",
                });
            } else if (type === "warning") {
                swal.fire({
                    title: `Warning`,
                    text: "Failed to reorder the selected positions.Try after some time.",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-warning",
                    },
                    icon: "warning",
                });
            }
        },
        confirmSelection() {
            if (!this.selectedStrategies.length) {
                alert("Please select at least one strategy");
                return;
            }
            const idSet = new Set();
            this.selectedStrategies.forEach(strategy => {
                strategy.orders.forEach(order => {
                    if (order.type === "Entry" && order.id) idSet.add(order.id);
                    else if (order.type === "Exit" && order.id) idSet.add(order.id);
                });
            });
            const type = this.tempFilterField.toUpperCase();
            const payload = {
                orderIds: Array.from(idSet),
                type: type
            };
            this.$store.dispatch("orderStore/orderRetry", payload, { root: true })
                .then(response => {
                    console.log("Success:", response.server.data);
                    this.showSwal('success');
                })
                .catch(error => {
                    this.showSwal('warning');
                    console.log(error);
                });
        }
    },
    mounted() {
        this.getOrderDetails();
    }
};
</script>
